export const data = [
  {
    "ID": 1,
    "country": "Bangladesh",
    "country_cn": "孟加拉国",
    "current_party_en": "Awami League",
    "current_party": "孟加拉国人民联盟",
    "current_diversity": 0.995,
    "current_populism": 0.073,
    "current_immigrant": 2.116,
    "current_lgbt": 2.055,
    "current_female": 2.025,
    "current_economy": 2.958,
    "next_party_en": "Awami League",
    "next_party": "孟加拉国人民联盟",
    "next_diversity": 0.995,
    "next_populism": 0.073,
    "next_immigrant": 2.116,
    "next_lgbt": 2.055,
    "next_female": 2.025,
    "next_economy": 2.958
  },
  {
    "ID": 2,
    "country": "Bhutan",
    "country_cn": "不丹",
    "current_party_en": "Druk Nyamrup Tshogpa",
    "current_party": "不丹统一党",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "People's Democratic Party",
    "next_party": "不丹人民民主党",
    "next_diversity": 0.1,
    "next_populism": 0.384,
    "next_immigrant": 1.374,
    "next_lgbt": 2.003,
    "next_female": 1.077,
    "next_economy": 3.374
  },
  {
    "ID": 3,
    "country": "Taiwan",
    "country_cn": "台湾",
    "current_party_en": "Democratic Progressive Party",
    "current_party": "台湾民进党",
    "current_diversity": 0.087,
    "current_populism": 0.144,
    "current_immigrant": 2.859,
    "current_lgbt": 3.185,
    "current_female": 3.691,
    "current_economy": 2.732,
    "next_party_en": "Democratic Progressive Party",
    "next_party": "台湾民进党",
    "next_diversity": 0.087,
    "next_populism": 0.144,
    "next_immigrant": 2.859,
    "next_lgbt": 3.185,
    "next_female": 3.691,
    "next_economy": 2.732
  },
  {
    "ID": 4,
    "country": "Comoros",
    "country_cn": "科摩罗",
    "current_party_en": "Convention for the Renewal of the Comoros",
    "current_party": "科摩罗复兴公约",
    "current_diversity": 0.844,
    "current_populism": 0.454,
    "current_immigrant": 1.99,
    "current_lgbt": 0.358,
    "current_female": 1.396,
    "current_economy": 3.889,
    "next_party_en": "Convention for the Renewal of the Comoros",
    "next_party": "科摩罗复兴公约",
    "next_diversity": 0.844,
    "next_populism": 0.454,
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 6,
    "country": "Finland",
    "country_cn": "芬兰",
    "current_party_en": "Independent",
    "current_party": "独立人士",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "National Coalition",
    "next_party": "芬兰民族联合党",
    "next_diversity": 0.031,
    "next_populism": 0.068,
    "next_immigrant": 2.608,
    "next_lgbt": 1.834,
    "next_female": 2.623,
    "next_economy": 4.604
  },
  {
    "ID": 7,
    "country": "El Salvador",
    "country_cn": "萨尔瓦多",
    "current_party_en": "Nuevas Ideas",
    "current_party": "新思想党",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Nuevas Ideas",
    "next_party": "新思想党",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 8,
    "country": "Azerbaijan",
    "country_cn": "阿塞拜疆",
    "current_party_en": "New Azerbaijan Party",
    "current_party": "新阿塞拜疆党",
    "current_diversity": 0.996,
    "current_populism": 0.121,
    "current_immigrant": 1.667,
    "current_lgbt": 0.631,
    "current_female": 1.051,
    "current_economy": 3.667,
    "next_party_en": "New Azerbaijan Party",
    "next_party": "新阿塞拜疆党",
    "next_diversity": 0.996,
    "next_populism": 0.121,
    "next_immigrant": 1.667,
    "next_lgbt": 0.631,
    "next_female": 1.051,
    "next_economy": 3.667
  },
  {
    "ID": 9,
    "country": "Pakistan",
    "country_cn": "巴基斯坦",
    "current_party_en": "Pakistan Tehreek-e-Insaf",
    "current_party": "巴基斯坦正义运动党",
    "current_diversity": 0.632,
    "current_populism": 0.596,
    "current_immigrant": 2.31,
    "current_lgbt": 1.495,
    "current_female": 2.036,
    "current_economy": 3.755,
    "next_party_en": "Pakistan Muslim League and Pakistan People's Party Coaliation",
    "next_party": "巴基斯坦穆盟和人民党联盟",
    "next_diversity": 0.514,
    "next_populism": 0.44,
    "next_immigrant": 1.753,
    "next_lgbt": 1.552,
    "next_female": 1.749,
    "next_economy": 3.495
  },
  {
    "ID": 10,
    "country": "Indonesia",
    "country_cn": "印度尼西亚",
    "current_party_en": "Indonesian Democratic Party of Struggle",
    "current_party": "印度尼西亚民主斗争党",
    "current_diversity": 0.495,
    "current_populism": 0.525,
    "current_immigrant": 1.789,
    "current_lgbt": 1.851,
    "current_female": 1.759,
    "current_economy": 2.292,
    "next_party_en": "Gerindra Party",
    "next_party": "大印尼运动党",
    "next_diversity": 0.961,
    "next_populism": 0.698,
    "next_immigrant": 0.869,
    "next_lgbt": 1.381,
    "next_female": 1.139,
    "next_economy": 2.299
  },
  {
    "ID": 11,
    "country": "Belarus",
    "country_cn": "白俄罗斯",
    "current_party_en": "",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 12,
    "country": "Senegal",
    "country_cn": "塞内加尔",
    "current_party_en": "Alliance for the Republic",
    "current_party": "争取共和联盟",
    "current_diversity": 0.483,
    "current_populism": 0.244,
    "current_immigrant": 2.351,
    "current_lgbt": 0.993,
    "current_female": 1.749,
    "current_economy": 3.363,
    "next_party_en": "Patriots of Senegal",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 13,
    "country": "Iran",
    "country_cn": "伊朗",
    "current_party_en": "United Front of Conservatives",
    "current_party": "伊朗保守联合阵线",
    "current_diversity": 0.997,
    "current_populism": 0.638,
    "current_immigrant": 1.977,
    "current_lgbt": 0.26,
    "current_female": 0.969,
    "current_economy": 4.705,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 14,
    "country": "Portugal",
    "country_cn": "葡萄牙",
    "current_party_en": "Portugese Socialist Party",
    "current_party": "葡萄牙社会党",
    "current_diversity": 0.019,
    "current_populism": 0.319,
    "current_immigrant": 2.775,
    "current_lgbt": 3.231,
    "current_female": 2.449,
    "current_economy": 2.463,
    "next_party_en": "Democratic Alliance",
    "next_party": "民主联盟",
    "next_diversity": 0.035,
    "next_populism": 0.231,
    "next_immigrant": 2.794,
    "next_lgbt": 1.925,
    "next_female": 0.866,
    "next_economy": 3.617
  },
  {
    "ID": 15,
    "country": "Russia",
    "country_cn": "俄罗斯",
    "current_party_en": "Independent",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Independent",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 18,
    "country": "South Korea",
    "country_cn": "韩国",
    "current_party_en": "",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 19,
    "country": "Madagascar",
    "country_cn": "马达加斯加",
    "current_party_en": "Young Malagasies Determined",
    "current_party": "马达加斯加青年准备着",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Young Malagasies Determined",
    "next_party": "马达加斯加青年准备着",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 20,
    "country": "Maldives",
    "country_cn": "马尔代夫",
    "current_party_en": "",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 21,
    "country": "Panama",
    "country_cn": "巴拿马",
    "current_party_en": "Democratic Revolutionary Party",
    "current_party": "民主革命党",
    "current_diversity": 0.483,
    "current_populism": 0.437,
    "current_immigrant": 1.67,
    "current_lgbt": 2.477,
    "current_female": 1.935,
    "current_economy": 2.496,
    "next_party_en": "Realizing Goals",
    "next_party": "实现目标",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 22,
    "country": "Dominican Republic",
    "country_cn": "多米尼加共和国",
    "current_party_en": "Modern Revolutionary Party",
    "current_party": "现代革命党",
    "current_diversity": 0.243,
    "current_populism": 0.331,
    "current_immigrant": 1.643,
    "current_lgbt": 2.204,
    "current_female": 1.615,
    "current_economy": 3.144,
    "next_party_en": "Modern Revolutionary Party",
    "next_party": "现代革命党",
    "next_diversity": 0.243,
    "next_populism": 0.331,
    "next_immigrant": 1.643,
    "next_lgbt": 2.204,
    "next_female": 1.615,
    "next_economy": 3.144
  },
  {
    "ID": 23,
    "country": "Iceland",
    "country_cn": "冰岛",
    "current_party_en": "Independent",
    "current_party": "独立人士",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Independent",
    "next_party": "独立人士",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 24,
    "country": "Mongolia",
    "country_cn": "蒙古",
    "current_party_en": "Mongolian People's Party",
    "current_party": "蒙古人民党",
    "current_diversity": 0.605,
    "current_populism": 0.853,
    "current_immigrant": 0.858,
    "current_lgbt": 0.833,
    "current_female": 1.329,
    "current_economy": 1.282,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 25,
    "country": "Mexico",
    "country_cn": "墨西哥",
    "current_party_en": "MORENA",
    "current_party": "国家复兴运动",
    "current_diversity": 0.7,
    "current_populism": 0.98,
    "current_immigrant": 2.416,
    "current_lgbt": 2.453,
    "current_female": 2.123,
    "current_economy": 1.523,
    "next_party_en": "MORENA",
    "next_party": "国家复兴运动",
    "next_diversity": 0.7,
    "next_populism": 0.98,
    "next_immigrant": 2.416,
    "next_lgbt": 2.453,
    "next_female": 2.123,
    "next_economy": 1.523
  },
  {
    "ID": 27,
    "country": "Belgium",
    "country_cn": "比利时",
    "current_party_en": "Open Flemish Liberals and Democrats",
    "current_party": "荷语开放自民党",
    "current_diversity": 0.038,
    "current_populism": 0.032,
    "current_immigrant": 2.416,
    "current_lgbt": 3.206,
    "current_female": 2.84,
    "current_economy": 3.594,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 28,
    "country": "Mauritania",
    "country_cn": "毛里塔尼亚",
    "current_party_en": "Equity Party/Union for the Republic",
    "current_party": "平权党/共和联盟",
    "current_diversity": 0.966,
    "current_populism": 0.077,
    "current_immigrant": 0.747,
    "current_lgbt": 1.003,
    "current_female": 1.637,
    "current_economy": 4.664,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 29,
    "country": "Rwanda",
    "country_cn": "卢旺达",
    "current_party_en": "Rwandan Patriotic Front",
    "current_party": "卢旺达爱国阵线",
    "current_diversity": 0.669,
    "current_populism": 0.378,
    "current_immigrant": 2.859,
    "current_lgbt": 2.302,
    "current_female": 3.873,
    "current_economy": 3.003,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 30,
    "country": "Austria",
    "country_cn": "奥地利",
    "current_party_en": "Austrian People's Party",
    "current_party": "奥地利人民党",
    "current_diversity": 0.068,
    "current_populism": 0.192,
    "current_immigrant": 1.281,
    "current_lgbt": 2.32,
    "current_female": 2.542,
    "current_economy": 3.722,
    "next_party_en": "Freedom Party of Austria",
    "next_party": "自由党",
    "next_diversity": 0.387,
    "next_populism": 0.782,
    "next_immigrant": 0.138,
    "next_lgbt": 1.594,
    "next_female": 1.078,
    "next_economy": 4.214
  },
  {
    "ID": 31,
    "country": "Mozambique",
    "country_cn": "莫桑比克",
    "current_party_en": "FRELIMO",
    "current_party": "莫桑比克解放阵线",
    "current_diversity": 0.802,
    "current_populism": 0.151,
    "current_immigrant": 2.194,
    "current_lgbt": 1.363,
    "current_female": 2.91,
    "current_economy": 2.393,
    "next_party_en": "FRELIMO",
    "next_party": "莫桑比克解放阵线",
    "next_diversity": 0.802,
    "next_populism": 0.151,
    "next_immigrant": 2.194,
    "next_lgbt": 1.363,
    "next_female": 2.91,
    "next_economy": 2.393
  },
  {
    "ID": 32,
    "country": "Georgia",
    "country_cn": "格鲁吉亚",
    "current_party_en": "Georgian Dream",
    "current_party": "格鲁吉亚梦想",
    "current_diversity": 0.586,
    "current_populism": 0.31,
    "current_immigrant": 1.858,
    "current_lgbt": 2.208,
    "current_female": 1.995,
    "current_economy": 2.615,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 33,
    "country": "Japan",
    "country_cn": "日本",
    "current_party_en": "Liberal Democractic Party",
    "current_party": "自民党",
    "current_diversity": 0.39,
    "current_populism": 0.134,
    "current_immigrant": 2.855,
    "current_lgbt": 1.741,
    "current_female": 1.092,
    "current_economy": 4.43,
    "next_party_en": "Liberal Democractic Party",
    "next_party": "自民党",
    "next_diversity": 0.39,
    "next_populism": 0.134,
    "next_immigrant": 2.855,
    "next_lgbt": 1.741,
    "next_female": 1.092,
    "next_economy": 4.43
  },
  {
    "ID": 34,
    "country": "Moldova",
    "country_cn": "摩尔多瓦",
    "current_party_en": "Party of Action and Solidarity",
    "current_party": "行动和团结党",
    "current_diversity": 0.139,
    "current_populism": 0.627,
    "current_immigrant": 2.544,
    "current_lgbt": 2.042,
    "current_female": 2.366,
    "current_economy": 3.155,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 35,
    "country": "United States of America",
    "country_cn": "美国",
    "current_party_en": "Democratic Party",
    "current_party": "民主党",
    "current_diversity": 0.276,
    "current_populism": 0.319,
    "current_immigrant": 1.859,
    "current_lgbt": 3.689,
    "current_female": 2.555,
    "current_economy": 2.216,
    "next_party_en": "Republican Party",
    "next_party": "共和党",
    "next_diversity": 0.719,
    "next_populism": 0.538,
    "next_immigrant": 0.922,
    "next_lgbt": 1.576,
    "next_female": 1.447,
    "next_economy": 4.505
  },
  {
    "ID": 37,
    "country": "Somaliland",
    "country_cn": "索马里兰",
    "current_party_en": "Peace, Unity, and Development Party",
    "current_party": "和平团结发展党",
    "current_diversity": 0.601,
    "current_populism": 0.515,
    "current_immigrant": 2.019,
    "current_lgbt": 1.188,
    "current_female": 1.084,
    "current_economy": 2.824,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 38,
    "country": "Ghana",
    "country_cn": "加纳",
    "current_party_en": "New Patriotic Party",
    "current_party": "新爱国党",
    "current_diversity": 0.265,
    "current_populism": 0.287,
    "current_immigrant": 1.752,
    "current_lgbt": 1.661,
    "current_female": 1.235,
    "current_economy": 3.643,
    "next_party_en": "New Patriotic Party",
    "next_party": "新爱国党",
    "next_diversity": 0.265,
    "next_populism": 0.287,
    "next_immigrant": 1.752,
    "next_lgbt": 1.661,
    "next_female": 1.235,
    "next_economy": 3.643
  },
  {
    "ID": 39,
    "country": "Lithuania",
    "country_cn": "立陶宛",
    "current_party_en": "Independent",
    "current_party": "独立人士",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Independent",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 40,
    "country": "India",
    "country_cn": "印度",
    "current_party_en": "Bharatiya Janata",
    "current_party": "印度人民党",
    "current_diversity": 0.833,
    "current_populism": 0.553,
    "current_immigrant": 1.097,
    "current_lgbt": 1.92,
    "current_female": 0.834,
    "current_economy": 4.697,
    "next_party_en": "Bharatiya Janata",
    "next_party": "印度人民党",
    "next_diversity": 0.833,
    "next_populism": 0.553,
    "next_immigrant": 1.097,
    "next_lgbt": 1.92,
    "next_female": 0.834,
    "next_economy": 4.697
  },
  {
    "ID": 41,
    "country": "North Macedonia",
    "country_cn": "北马其顿",
    "current_party_en": "Social Democratic Union of Macedonia",
    "current_party": "马其顿社会民主联盟党",
    "current_diversity": 0.277,
    "current_populism": 0.345,
    "current_immigrant": 1.868,
    "current_lgbt": 2.814,
    "current_female": 3.487,
    "current_economy": 1.87,
    "next_party_en": "Internal Macedonian Revolutionary Organization – Democratic Party for Macedonian National Unity",
    "next_party": "马其顿内部革命组织—民族统一民主党",
    "next_diversity": 0.796,
    "next_populism": 0.189,
    "next_immigrant": 1.207,
    "next_lgbt": 0.77,
    "next_female": 2.405,
    "next_economy": 4.369
  },
  {
    "ID": 43,
    "country": "Togo",
    "country_cn": "多哥",
    "current_party_en": "Union for the Republic",
    "current_party": "保卫共和联盟",
    "current_diversity": 0.912,
    "current_populism": 0.06,
    "current_immigrant": 3.293,
    "current_lgbt": 1.316,
    "current_female": 1.613,
    "current_economy": 4.384,
    "next_party_en": "Union for the Republic",
    "next_party": "保卫共和联盟",
    "next_diversity": 0.912,
    "next_populism": 0.06,
    "next_immigrant": 3.293,
    "next_lgbt": 1.316,
    "next_female": 1.613,
    "next_economy": 4.384
  },
  {
    "ID": 44,
    "country": "United Kingdom",
    "country_cn": "英国",
    "current_party_en": "Conservative",
    "current_party": "保守党",
    "current_diversity": 0.348,
    "current_populism": 0.364,
    "current_immigrant": 1.071,
    "current_lgbt": 2.298,
    "current_female": 2.425,
    "current_economy": 4.638,
    "next_party_en": "Labour",
    "next_party": "工党",
    "next_diversity": 0.116,
    "next_populism": 0.514,
    "next_immigrant": 2.536,
    "next_lgbt": 3.122,
    "next_female": 2.719,
    "next_economy": 1.024
  },
  {
    "ID": 45,
    "country": "South Africa",
    "country_cn": "南非",
    "current_party_en": "African National Congress",
    "current_party": "非洲人国民大会",
    "current_diversity": 0.194,
    "current_populism": 0.693,
    "current_immigrant": 1.829,
    "current_lgbt": 2.984,
    "current_female": 3.417,
    "current_economy": 1.79,
    "next_party_en": "African National Congress",
    "next_party": "非洲人国民大会",
    "next_diversity": 0.194,
    "next_populism": 0.693,
    "next_immigrant": 1.829,
    "next_lgbt": 2.984,
    "next_female": 3.417,
    "next_economy": 1.79
  },
  {
    "ID": 46,
    "country": "Tunisia",
    "country_cn": "突尼斯",
    "current_party_en": "Independent",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Independent",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 47,
    "country": "Solomon Islands",
    "country_cn": "所罗门群岛",
    "current_party_en": "Ownership, Unity and Responsibility Party",
    "current_party": "OUR党",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Ownership, Unity and Responsibility Party",
    "next_party": "OUR党",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 48,
    "country": "Algeria",
    "country_cn": "阿尔及利亚",
    "current_party_en": "Independent",
    "current_party": "独立人士",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Independent",
    "next_party": "独立人士",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 51,
    "country": "Venezuela",
    "country_cn": "委内瑞拉",
    "current_party_en": "United Socialist Party of Venezuela",
    "current_party": "委内瑞拉统一社会主义党",
    "current_diversity": 0.998,
    "current_populism": 0.986,
    "current_immigrant": 1.982,
    "current_lgbt": 2.23,
    "current_female": 1.721,
    "current_economy": 0.59,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 52,
    "country": "Jordan",
    "country_cn": "约旦",
    "current_party_en": "Islamic Action Front",
    "current_party": "伊斯兰行动阵线",
    "current_diversity": 0.624,
    "current_populism": 0.717,
    "current_immigrant": 1.778,
    "current_lgbt": 0.194,
    "current_female": 1.052,
    "current_economy": 3.786,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 53,
    "country": "Botswana",
    "country_cn": "博兹瓦纳",
    "current_party_en": "Botswana Democratic Party",
    "current_party": "博兹瓦纳民主党",
    "current_diversity": 0.278,
    "current_populism": 0.208,
    "current_immigrant": 1.943,
    "current_lgbt": 2.159,
    "current_female": 1.291,
    "current_economy": 3.484,
    "next_party_en": "Umbrella for Democratic Change",
    "next_party": "民主改革联盟",
    "next_diversity": 0.155,
    "next_populism": 0.665,
    "next_immigrant": 1.295,
    "next_lgbt": 2.698,
    "next_female": 1.203,
    "next_economy": 2.089
  },
  {
    "ID": 54,
    "country": "Chad",
    "country_cn": "乍得",
    "current_party_en": "Patriotic Salvation Movement",
    "current_party": "爱国拯救运动",
    "current_diversity": 0.942,
    "current_populism": 0.237,
    "current_immigrant": 2.021,
    "current_lgbt": 2.058,
    "current_female": 1.049,
    "current_economy": 3.846,
    "next_party_en": "Patriotic Salvation Movement",
    "next_party": "爱国拯救运动",
    "next_diversity": 0.942,
    "next_populism": 0.237,
    "next_immigrant": 2.021,
    "next_lgbt": 2.058,
    "next_female": 1.049,
    "next_economy": 3.846
  },
  {
    "ID": 55,
    "country": "Romania",
    "country_cn": "罗马尼亚",
    "current_party_en": "Independent",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Social Democratic Party",
    "next_party": "社会民主党",
    "next_diversity": 0.411,
    "next_populism": 0.392,
    "next_immigrant": 1.508,
    "next_lgbt": 1.263,
    "next_female": 2.558,
    "next_economy": 2.021
  },
  {
    "ID": 56,
    "country": "Uzbekistan",
    "country_cn": "乌兹别克斯坦",
    "current_party_en": "Uzbekistan Liberal Democratic Party",
    "current_party": "乌兹别克斯坦自由民主党",
    "current_diversity": 0.73,
    "current_populism": 0.206,
    "current_immigrant": 1.967,
    "current_lgbt": 1.133,
    "current_female": 1.772,
    "current_economy": 3.684,
    "next_party_en": "Uzbekistan Liberal Democratic Party",
    "next_party": "乌兹别克斯坦自由民主党",
    "next_diversity": 0.73,
    "next_populism": 0.206,
    "next_immigrant": 1.967,
    "next_lgbt": 1.133,
    "next_female": 1.772,
    "next_economy": 3.684
  },
  {
    "ID": 57,
    "country": "Croatia",
    "country_cn": "克罗地亚",
    "current_party_en": "Independent",
    "current_party": "独立人士",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "HDZ Coalition",
    "next_party": "民主共同体执政联盟",
    "next_diversity": 0.201,
    "next_populism": 0.238,
    "next_immigrant": 1.51,
    "next_lgbt": 1.803,
    "next_female": 1.858,
    "next_economy": 3.857
  },
  {
    "ID": 58,
    "country": "Czech Republic",
    "country_cn": "捷克共和国",
    "current_party_en": "ODS-TOP9",
    "current_party": "公民民主党",
    "current_diversity": 0.051,
    "current_populism": 0.184,
    "current_immigrant": 1.452,
    "current_lgbt": 1.273,
    "current_female": 1.199,
    "current_economy": 4.231,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 60,
    "country": "Mauritius",
    "country_cn": "毛里求斯",
    "current_party_en": "Militant Socialist Movement",
    "current_party": "社会主义战斗党",
    "current_diversity": 0.556,
    "current_populism": 0.299,
    "current_immigrant": 2.182,
    "current_lgbt": 1.993,
    "current_female": 1.056,
    "current_economy": 2.662,
    "next_party_en": "Labour Party",
    "next_party": "工党",
    "next_diversity": 0.564,
    "next_populism": 0.452,
    "next_immigrant": 2.163,
    "next_lgbt": 2.011,
    "next_female": 1.049,
    "next_economy": 2.357
  },
  {
    "ID": 61,
    "country": "Namibia",
    "country_cn": "纳米比亚",
    "current_party_en": "South West Africa People's Organization",
    "current_party": "西南非人民组织",
    "current_diversity": 0.81,
    "current_populism": 0.398,
    "current_immigrant": 2.064,
    "current_lgbt": 1.53,
    "current_female": 3.69,
    "current_economy": 2.986,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 62,
    "country": "Slovakia",
    "country_cn": "斯洛伐克",
    "current_party_en": "Progressive Slovakia",
    "current_party": "进步斯洛伐克",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "Voice – Social Democracy",
    "next_party": "声音党",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 63,
    "country": "Sri Lanka",
    "country_cn": "斯里兰卡",
    "current_party_en": "United National Party",
    "current_party": "统一国民党",
    "current_diversity": 0.663,
    "current_populism": 0.273,
    "current_immigrant": 1.338,
    "current_lgbt": 1.611,
    "current_female": 1.119,
    "current_economy": 4.158,
    "next_party_en": "People's Liberation Front",
    "next_party": "人民解放前线",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 64,
    "country": "Syria",
    "country_cn": "叙利亚",
    "current_party_en": "Arab Socialist Ba'ath Party",
    "current_party": "阿拉伯复兴社会党",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 65,
    "country": "France",
    "country_cn": "法国",
    "current_party_en": "",
    "current_party": "",
    "current_diversity": "",
    "current_populism": "",
    "current_immigrant": "",
    "current_lgbt": "",
    "current_female": "",
    "current_economy": "",
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
  {
    "ID": 67,
    "country": "Bulgaria",
    "country_cn": "保加利亚",
    "current_party_en": "GERB-SDS",
    "current_party": "公民党与民主力量联盟",
    "current_diversity": 0.152,
    "current_populism": 0.393,
    "current_immigrant": 1.863,
    "current_lgbt": 1.967,
    "current_female": 1.584,
    "current_economy": 3.388,
    "next_party_en": "",
    "next_party": "",
    "next_diversity": "",
    "next_populism": "",
    "next_immigrant": "",
    "next_lgbt": "",
    "next_female": "",
    "next_economy": ""
  },
]